import {
  Goal,
  createGoalDateKey,
  createGoalFromTemplate,
  createGoalKey,
  createGoalModel,
  generateGoalInstanceFromTemplate,
  getGoalCompletionProgress,
  getGoalFrequencyDisplayText,
  getGoalPeriodText,
  getGoalProgressPercentage,
  incrementGoalCompletion,
  toggleCategoryInGoal,
} from '@akin-home/goals';
import {
  goalGraphqlToModel,
  goalModelToCreateGraphql,
  goalModelToUpdateGraphql,
} from '@akin-home/goals/frontend';
import { UserModel } from '@akin-home/user';
import { pipe } from '@akin-home/utils/fp';

/** Assigns the given user as the primary user for the goal */
export const assignUserToGoal = (user: UserModel) => (goal: Goal) => ({
  ...goal,
  participant_ids: [user.id],
  habitatID: user.habitatID,
});

export const generateGoalInstanceFromTemplateForUser = ({
  goal,
  user,
}: {
  goal: Goal;
  user: UserModel;
}): Goal =>
  pipe(generateGoalInstanceFromTemplate, assignUserToGoal(user))(goal);

export {
  createGoalDateKey,
  createGoalFromTemplate,
  createGoalKey,
  createGoalModel,
  generateGoalInstanceFromTemplate,
  getGoalCompletionProgress,
  getGoalFrequencyDisplayText,
  getGoalPeriodText,
  getGoalProgressPercentage,
  goalGraphqlToModel,
  goalModelToCreateGraphql,
  goalModelToUpdateGraphql,
  incrementGoalCompletion,
  toggleCategoryInGoal,
};
